import React from 'react';
import ReactDOM from 'react-dom';
import Portfolio from './Portfolio';
import * as serviceWorker from './serviceWorker';
import './aesthetic/index.css';

ReactDOM.render(
	<React.StrictMode>
		<Portfolio />
	</React.StrictMode>,
	document.getElementById('root')
);

serviceWorker.unregister();